<template>
  <div class="row">
    <div class="panel bg-transparent columns large-6 medium-12 large-centered text-center">
      <div v-if="componentReady">
        <keep-alive>
          <component
            :display-data="displayData"
            :is="tabComponents[tabIndex]"
            @display-change="val => displayData = val"
            @tab-change="tabChanged"
            @complete="$emit('stage-change', 2)"
          />
        </keep-alive>
      </div>
      <div v-if="!componentReady">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </div>

      <modal
        class="ge-notification-modal"
        v-if="showGeNotice"
        :size="`medium`"
        :show-close-button="true"
        @close="showGeNotice = false">
        <div class="row">
          <div class="medium-4 columns">
            <img :src="geImg" class="ge-notice-icon" />
          </div>
          <div class="medium-8 text-left columns ge-notice-text">
            <p v-text="t('register.ge_admin_congratulations')"></p>
            <ul>
              <li v-text="t('register.ge_admin_bulletin1')"></li>
              <li v-text="t('register.ge_admin_bulletin2')"></li>
              <li v-text="t('register.ge_admin_bulletin3')"></li>
            </ul>
            <p v-text="t('register.ge_admin_payment')"></p>
            <p v-text="t('register.ge_admin_payment_complete')"></p>
            <p v-text="t('register.ge_admin_payment_question')"></p>
            <p v-text="t('register.ge_admin_welcome')"></p>
            <p class="no-margin">
              <button class="tiny" @click="showGeNotice = false" v-text="t('templates.page.IC_0001')"></button>
            </p>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import $           from 'jquery';
import AdminEmail  from './Tabs/AdminEmail.vue';
import AdminDetail from './Tabs/AdminDetail.vue';
import Modal       from '../Ui/Modal.vue';
import geImg       from './ge.png';

export default {

  components: {
    AdminEmail,
    AdminDetail,
    Modal
  },

  props: ['tab', 'geContractor'],

  data() {
    return {
      componentReady: false,
      displayData: [],
      tabIndex: 0,
      showGeNotice: false,
      tabComponents: [
        'admin-email',
        'admin-detail',
      ],
      geImg: geImg
    };
  },

  beforeMount() {
    $.post('/register/tab-data/admin', (data) => {
      this.displayData = data;
      this.componentReady = true;
    });
  },

  mounted() {
    if (this.geContractor) {
      this.showGeNotice = true;
    }
  },

  methods: {
    tabChanged(val) {
      $('html, body').animate({ scrollTop: 100 }, 'slow');

      this.tabIndex = val;
    },
  },
};
</script>
<style>
  .text-left {
    text-align: left;
  }

  .ge-notice-text {
    padding: 30px 30px 0 30px;
    font-weight: 700;
  }

  .ge-notice-text p {
    font-weight: 700;
  }

  .ge-notice-icon {
    transform: translateY(50%);
  }

  .ge-notification-modal .modal-container {
    border-radius: 30px;
  }

  .ge-notice-text h5 {
    text-decoration: underline;
  }
  .ge-note {
    font-weight: 400;
  }
</style>